/**
 * Created by olga on 26.03.2025
 */

const ScoreBarRewardWindow = CleverappsWindow.extend({
    onWindowLoaded: function (rewardOptions) {
        this.rewardOptions = rewardOptions;

        this.noActionButtons = connector.platform.oneOf(connector.YANDEX)
            && cleverapps.config.type === "merge2";

        this._super({
            name: "ScoreBarRewardWindow",
            content: this.createContent(),
            noBackground: true,
            closeButton: this.noActionButtons
        });
    },

    createPrizeIcon: function () {
        const prizeIcon = this.prizeIcon = new cc.Sprite(this.rewardOptions.image);
        prizeIcon.setVisible(false);

        StandartAnimations.rays(prizeIcon);

        return prizeIcon;
    },

    createContent: function () {
        const styles = cleverapps.styles.ScoreBarRewardWindow;

        const content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        content.setContentSize(cleverapps.styles.ScoreBarRewardWindow);

        if (styles.bg) {
            const bg = new cc.Scale9Sprite(bundles.score_bar_window.frames.window_bg_png);
            bg.setContentSize2(content.getContentSize());
            content.addChild(bg);
            bg.setAlignment(styles.bg);
        }

        const prizeIcon = this.createPrizeIcon();
        content.addChild(prizeIcon);
        prizeIcon.setAlignment(styles.prize);

        const title = cleverapps.UI.generateOnlyText(Messages.get("RewardWindow.title"), cleverapps.styles.FONTS.NOBG_WINDOW_TITLE_TEXT);
        content.addChild(title);
        title.setAlignment(styles.title);

        if (this.rewardOptions.avatar) {
            const avatar = cleverapps.persist.acceptNode("ScoreBarAvatar");
            const avatarLabel = this.createAvatarLabel(avatar);
            content.addChild(avatarLabel);
            avatarLabel.setAlignment(styles.avatarLabel);
        }

        if (!this.noActionButtons) {
            const buttons = this.createButtons();
            content.addChild(buttons);
            buttons.setAlignment(styles.buttons);
        }

        return content;
    },

    createAvatarLabel: function (avatar) {
        avatar.removeFromParent(false);
        avatar.setVisible(true);
        return new TextWithIcon(`${Messages.get("ScoreBarReward.avatarLabel")}@@`, {
            font: cleverapps.styles.FONTS.SCORE_SECONDARY_VALUE_TEXT,
            icons: {
                "@@": avatar
            },
            iconScale: avatar.getScale()
        });
    },

    createButtons: function () {
        const styles = cleverapps.styles.ScoreBarRewardWindow.buttons;

        const acceptButton = new cleverapps.UI.Button({
            width: styles.acceptButton.width,
            height: styles.acceptButton.height,
            icons: {
                "%%": bundles.buttons_inlined_icons.frames.ad_icon_png
            },
            text: `${Messages.get("Accept")} %%`,
            onClicked: this.onAccept.bind(this)
        });

        const cancelButton = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.button_red,
            width: styles.rejectButton.width,
            height: styles.rejectButton.height,
            text: Messages.get("Cancel"),
            onClicked: this.onReject.bind(this)
        });

        return new cleverapps.Layout([cancelButton, acceptButton], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
    },

    onAccept: function () {
        if (this.closed) {
            return;
        }

        cleverapps.persist.sendNode(this.prizeIcon, "ScoreBarAvatar");

        const onAccept = this.rewardOptions.onAccept || function () {};
        const onReject = this.rewardOptions.onReject || function () {};
        cleverapps.rewardedAdsManager.playRewarded(AdsLimits.TYPES.SCORE_BAR, onAccept, () => {
            cleverapps.persist.acceptNode("ScoreBarAvatar");
            onReject();
        });

        this.close();
    },

    onReject: function () {
        if (this.closed) {
            return;
        }

        const onReject = this.rewardOptions.onReject || function () {};

        onReject();
        this.close();
    },

    onShow: function () {
        this._super();

        const moveOffset = cleverapps.styles.ScoreBarRewardWindow.moveOffset;
        this.prizeIcon.setOpacity(0);

        this.prizeIcon.runAction(
            new cc.Sequence(
                new cc.MoveBy(0, 0, -moveOffset),
                new cc.Show(),
                new cc.Spawn(
                    new cc.MoveBy(0.2, 0, moveOffset).easing(cc.easeIn(1)),
                    new cc.FadeIn(0.2).easing(cc.easeIn(1))
                )
            )
        );
    },

    beforeCloseAnimation: function (callback) {
        this.prizeIcon.setVisible(false);

        callback();
    },

    onClose: function () {
        if (this.noActionButtons) {
            cleverapps.persist.sendNode(this.prizeIcon, "ScoreBarAvatar");

            const onAccept = this.rewardOptions.onAccept || function () {};
            cleverapps.rewardedAdsManager.showInterstitial({
                limit: AdsLimits.TYPES.INTERSTITIAL,
                placement: AdsLimits.TYPES.INTERSTITIAL_OTHER
            }, onAccept);
        }
    },

    listBundles: function () {
        return ["score_bar_window"];
    }
});

cleverapps.styles.ScoreBarRewardWindow = {
    width: 800,
    height: 1000,
    title: {
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: -40 }
    },

    prize: {
        x: { align: "center" },
        y: { align: "center", dy: 100 }
    },

    avatarLabel: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 250 }
    },

    buttons: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 75 },

        margin: 50,

        acceptButton: {
            width: 250,
            height: 100
        },

        rejectButton: {
            width: 200,
            height: 100
        }
    },

    moveOffset: 50,

    bg: false
};
